import { Box, Button } from "@mui/material";

interface CustomButtonBitacoraProps {
  handleButtonClick: (value: number) => void
  activeButton: number
}

export default function BitacoraGroupButton({ handleButtonClick, activeButton }: CustomButtonBitacoraProps) {

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', }}>
      <Button
        onClick={() => handleButtonClick(1)}
        sx={{
          m: 1,
          height: '30px',
          width: '100%',
          backgroundColor: activeButton === 1 ? '#2C4E80' : 'white',
          color: activeButton === 1 ? 'white' : '#6C737F',
          //border: '1px solid #6C737F',
          '&:hover': {
            backgroundColor: activeButton === 1 ? '#2C4E80' : 'lightgray',
            color: activeButton === 1 ? 'white' : 'blue',
          }
        }}
      >
        PENDIENTE
      </Button>

      <Button
        onClick={() => handleButtonClick(2)}
        sx={{
          m: 1,
          height: '30px',
          width: '100%',
          backgroundColor: activeButton === 2 ? '#2C4E80' : 'white',
          color: activeButton === 2 ? 'white' : '#6C737F',
          //border: '1px solid blue',
          '&:hover': {
            backgroundColor: activeButton === 2 ? '#2C4E80' : 'lightgray',
            color: activeButton === 2 ? 'white' : 'blue',
          }
        }}
      >
        RESUELTO
      </Button>

      {/* <Button
        onClick={() => handleButtonClick(3)}
        sx={{
          m: 1,
          height: '30px',
          width: '100%',
          backgroundColor: activeButton === 3 ? '#001F3F' : 'white',
          color: activeButton === 3 ? 'white' : '#6C737F',
          //border: '1px solid blue',
          '&:hover': {
            backgroundColor: activeButton === 3 ? '#001F3F' : 'lightgray',
            color: activeButton === 3 ? 'white' : 'blue',
          }
        }}
      >
        TODOS
      </Button> */}
    </Box>

  )
}
